import { css, styled } from 'styled-components';

import { FesLink } from '../../core/link/FesLink';

export const S = {
  AccountMenuWrapper: styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;
    height: var(--top-nav-height);
  `,

  IconLink: styled(FesLink)`
    ${({ theme }) => css`
      display: flex;
      align-items: center;
      height: var(--top-nav-height);
      line-height: var(--top-nav-height);
      padding: ${theme.padding.none};
      color: ${theme.colors.content.component.header.color};
      text-decoration: none;
      cursor: pointer;

      &:hover,
      &:focus-visible {
        path {
          fill: ${theme.colors.content.component.header.hover};
        }
      }

      &:focus-visible {
        outline-offset: -2px;
      }
    `}
  `,

  IconWrapper: styled.span`
    ${({ theme }) => css`
      display: inline-block;
      width: ${theme.size[4]};
      height: 100%;
    `}
  `,

  Toggle: styled.button`
    ${({ theme }) => css`
      position: absolute;
      left: 16px;
      height: 100%;
      align-items: center;
      align-self: stretch;
      background: transparent;
      border: 0;
      cursor: pointer;
      display: flex;
      justify-content: center;
      opacity: 0;
      width: ${theme.size[4]};

      &::after {
        border-bottom: 1px solid ${theme.colors.content.component.header.color};
        border-right: 1px solid ${theme.colors.content.component.header.color};
        content: '';
        height: 6px;
        transform: translateY(-2px) rotate(45deg);
        transition: transform 150ms ease-in-out;
        width: 6px;

        @media (prefers-reduced-motion: reduce) {
          transition: none;
        }
      }

      &[aria-expanded='true']::after {
        transform: translateY(2px) rotate(225deg);
      }

      &:focus-visible {
        opacity: 1;
        outline-offset: -2px;
      }
    `}
  `,

  Dropdown: styled.div<{ $isOpen: boolean }>`
    ${({ theme, $isOpen }) => css`
      display: ${$isOpen ? 'block' : 'none'};
      position: fixed;
      top: var(--top-nav-height);
      right: 0;
      width: 240px;
      background-color: ${theme.colors.background.base};
      box-shadow: 0 4px 16px rgb(0 0 0 / 8%);
      padding: ${theme.padding.md};
      z-index: 505;
      box-sizing: border-box;
    `}
  `,

  DropdownTitle: styled.h3`
    ${({ theme }) => css`
      font-size: ${theme.font.size[3]};
      font-weight: ${theme.variables.font.weight.medium};
      color: ${theme.colors.content.component.header.color};
      padding: ${theme.padding.none} ${theme.padding.none} ${theme.padding.sm};
      line-height: 1.4;
    `}
  `,

  MenuList: styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
  `,

  MenuItem: styled.li`
    ${({ theme }) => css`
      list-style: none;
      margin: 0;
      padding: ${theme.padding['2xs']} 0;
    `}
  `,

  MenuLink: styled(FesLink)`
    ${({ theme }) => css`
      color: ${theme.colors.content.component.header.hover};
      font-size: ${theme.font.size[3]};
      font-weight: ${theme.variables.font.weight.regular};
      line-height: 1.4;

      &:hover,
      &:focus-visible {
        color: ${theme.colors.content.component.header.color};
      }

      &:focus-visible {
        outline-offset: 4px;
      }
    `}
  `,

  AccordionButton: styled.button`
    ${({ theme }) => css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      color: ${theme.colors.content.component.header.hover};
      font-size: ${theme.font.size[3]};
      font-weight: ${theme.variables.font.weight.regular};
      line-height: 1.4;

      &:hover,
      &:focus-visible {
        color: ${theme.colors.content.component.header.color};
      }

      &:focus-visible {
        outline-offset: 4px;
      }
    `}
  `,

  AccordionIcon: styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: ${({ theme }) => theme.colors.content.component.header.color};
    user-select: none;
  `,

  SubMenuList: styled.ul`
    ${({ theme }) => css`
      padding: ${theme.padding['2xs']} 0 0 ${theme.padding.md};
      display: flex;
      flex-direction: column;
    `}
  `,

  SubMenuItem: styled.li`
    ${({ theme }) => css`
      list-style: none;
      padding: ${theme.padding['2xs']} 0;
    `}
  `,

  SubMenuLink: styled(FesLink)`
    ${({ theme }) => css`
      color: ${theme.colors.content.component.header.hover};
      font-size: ${theme.font.size[3]};
      font-weight: ${theme.variables.font.weight.regular};
      line-height: 16px;
      text-decoration: none;

      &:hover,
      &:focus-visible {
        color: ${theme.colors.content.component.header.color};
      }

      &:focus-visible {
        outline-offset: 4px;
      }
    `}
  `,
};
